export default __webpack_public_path__ + "static/media/exchange.148fec04.svg";